import { React } from "react";

import Transitions from "./Transitions";
import { WorkHeader } from "./Header";

function HeroHeader(props) {
  return (
    <Transitions>
      <section className="main" id="projectHeader">
        <div
          className="main__header"
          style={{
            backgroundImage: ` linear-gradient(
      360deg,
      #22232E -2.07%,
      rgba(28, 28, 28, 0) 40.92%
    ),
    url(${props.hero_img})`,
            height: "100%",
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "30% center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* <video autoPlay muted playsInline loop style={{height:'100%', objectFit:'cover'}}>
              <source src={props.video} loading="lazy" type="video/mp4"  />
              Your browser does not support the video tag.
            </video> */}
<div
              className="header__outer"
              style={{
                position: "absolute",
                right: "0",
                bottom: "0",
                left: "50%",
                transform: "translate(-50%, 0)",
                width: "100%",
                padding: "0 6rem",
                height: "auto",
                backgroundColor: "rgba(28, 28, 28, 0.4)",
              }}
            >
              <WorkHeader
                textColour="#ffffff"
                smallText={props.type}
                largeText={props.name}
                italics={props.italics}
                largeText2={props.name2}
              ></WorkHeader>
            </div>
          {/* <div className="hero__shadow" style={{width:'100vw', height:'40vh', background:'rgba(34, 35, 46, 0.5)', bottom:'0', position:'absolute'}}></div> */}
         
        </div>
      </section>
    </Transitions>
  );
}

export default HeroHeader;
